export const mapPageToBreadcrumbsItem = <T extends {name: string; url?: string}>(page: T): $w.Breadcrumbs.Item => {
  return {
    label: page.name,
    link: page.url,
  };
};
